import _ from 'lodash'

import { filters } from '../../configuration/filtering'
import { exact } from './validators'

export function filterToursByField(tours, filterKey, filterSet, exactMatch = false) {
  return _.filter(tours, tour => {
    const validator = _.get(filters, `[${filterKey}].validator`, () => true)
    const tourFieldToFilterBy = _.get(tour, `[${filterKey}]`)
    return exactMatch
      ? exact(filterSet, tourFieldToFilterBy)
      : validator(filterSet, tourFieldToFilterBy)

  })
}
